export default __webpack_public_path__ + "static/resources-adjudication-198384f93c59c4dd46ae90224d3e5c3b.jpg";